import axios from 'axios'
import {getApiUrls,getApiUpdateUrls} from "@/http/base.http";

export function getNetworkType(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}network/type/get`, payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}

export function addNetworkType(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}network/type/add`,payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
export function getByIdNetworkType(id) {
    const { env } = getApiUrls();
    return axios.get(`${env}network/type/detail/${id}`).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
export function updateNetworkType(payload) {
    const {envU } = getApiUpdateUrls();
    return axios.put(`${envU}network/type/update`,payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}